import { DatePipe, JsonPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { Answer } from 'src/app/models/Answer.model';
import { ModularQuestion } from 'src/app/models/modularQuestion.model';
import { Question } from 'src/app/models/question.model';
import { EQuestionType } from 'src/app/models/questionType.model';
import { environment } from 'src/environment';

@Pipe({
  name: 'answerSwitchType',
  standalone: true,
})
export class AnswerSwitchTypePipe implements PipeTransform {
  eQuestionType = EQuestionType;
  datePipe = inject(DatePipe);

  transform(answer?: Answer | undefined, question?: Question | ModularQuestion): unknown {
    // if (!answer) {
    //   return environment.lang==="he"?"אין תשובה":"no reply";
    // }
    switch (question?.type?.id) {
      case this.eQuestionType.Fill:
      case this.eQuestionType.FreeText:
        return answer?.textAnswer == "" ? "-" : answer?.textAnswer ?? "-";


      case this.eQuestionType.PhoneNumber:
        var dial = answer?.multiOptionsAnswer?.replace(/\+/g, '');
        //to hebrue
        var dir = environment.lang;
        if (dir === "he") {
          var x = answer?.textAnswer == "" || !answer?.textAnswer ? "-" : answer?.textAnswer + " " + dial + "+";
          return x;
        } else {
          var x = answer?.textAnswer == "" || !answer?.textAnswer ? "-" : answer?.multiOptionsAnswer + " " + answer?.textAnswer;
          return x;
        }
      case this.eQuestionType.Multi:
        return answer?.multiOptionsAnswer;
      case this.eQuestionType.Range:
        return answer?.intAnswer;
      case this.eQuestionType.Autocomplete:
      case this.eQuestionType.Mark:
        {
          var arr = question?.optionsList?.answerOptionItem as any[];
          if (arr)
            return arr.find(ans => ans?.guid == answer?.optionItemGuid)?.name;
          else return "-";
        }
      case this.eQuestionType.Date:
        if (!answer?.dateAnswerNTZ) {
          return "-";
        } else {
          return this.datePipe.transform(answer?.dateAnswerNTZ, 'dd/MM/yyyy') ?? "-";
        }
      case this.eQuestionType.QuestionsGroup:
        return ""
      default:

        return `-`;
    }
  }
}
